module.exports = __webpack_public_path__ + "img/pingdingshanjiaotong.1afc9a5f.png";